import axios from 'axios'
import { getFormattedMoneyString, getLocalURL } from '../../../scripts/helpers/globale'
import { passwordRecoverMessage } from '~/helpers/account'

export default class AccountPage {
  constructor(component) {
    this.dom = {
      $component: component,
      $accountInfo: component.querySelector('.js-accountInfo'),
      $accountOrders: component.querySelector('.js-accountOrders'),
      $accountRewards: component.querySelector('.js-accountRewards'),
      $wishlistItems: component.querySelectorAll('.js-wishListItem'),
      $wishlistLogoutLink: document.querySelector('.js-wishlistLogoutLink'),
      $wishlistRootLink: document.querySelector('.js-wishlistRootLink'),
      $countrySelect: document.querySelector('.js-globaleCountrySelect'),
    }
    this.state = {
      activeLinkClass: 'activeLink',
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom, state } = this
    const url = new URL(document.location)
    const displayParam = url.searchParams.get('display')
    const localURL = getLocalURL()

    if (displayParam === 'orders') {
      dom.$accountInfo.style.display = 'none'
      dom.$accountOrders.style.display = 'block'
      dom.$component.querySelector(`.js-accountNavLink[href="${localURL}account?display=orders"]`).classList.add(state.activeLinkClass)
    } else if (displayParam === 'rewards') {
      dom.$accountInfo.style.display = 'none'
      dom.$accountRewards.style.display = 'block'
      dom.$component.querySelector(`.js-accountNavLink[href="${localURL}account?display=rewards"]`).classList.add(state.activeLinkClass)
    } else {
      dom.$component.querySelector(`.js-accountNavLink[href="${url.pathname}"]`).classList.add(state.activeLinkClass)
    }

    if (dom.$wishlistLogoutLink) {
      dom.$wishlistLogoutLink.href = getLocalURL('/account/logout')
    }

    if (dom.$wishlistRootLink) {
      dom.$wishlistRootLink.href = localURL
    }

    if (dom.$countrySelect.dataset.countryCode !== 'US') {
      this.convertPrices()
    }

    passwordRecoverMessage(dom.$component)
  }

  convertPrices() {
    const { dom } = this

    if (dom.$wishlistItems.length === 0) {
      return
    }

    dom.$wishlistItems.forEach(async $item => {
      const priceArray = await this.getPrice($item)

      $item.querySelector('.product-price').textContent = getFormattedMoneyString(priceArray.price)
      if ($item.querySelector('.product-compare-price')) {
        $item.querySelector('.product-compare-price').textContent = getFormattedMoneyString(priceArray.compare_at_price)
      }
    })
  }

  async getPrice(item) {
    const productHandle = item.dataset.productHandle
    const url = getLocalURL(`/products/${productHandle}.js`)

    try {
      const { data: { compare_at_price, price } } = await axios.get(url)

      return { compare_at_price, price }
    } catch (res) {
      console.log('Error getting product data', res)
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.AccountPage = this
  }
}
